import { FunctionComponent } from "react";
import { PageTitle } from "src/components/generic";
import TopNav from "src/components/navigation/TopNav";
import { ConfirmAccountForm } from "src/components/forms";

interface IConfirmAccountProps {
    email: string;
    cusId: string;
    tier: string;
}

const ConfirmAccount: FunctionComponent<IConfirmAccountProps> = ({ email, cusId, tier }) => (
    <div>
        <div className="px-3">
            <TopNav />
        </div>
        <div>
            <PageTitle title="Confirm Your Account" />
                
            <ConfirmAccountForm email={email} cusId={cusId} tier={tier} />
        </div>
    </div>
);

export default ConfirmAccount;